import Component from '../vendor/Component'
import Choices from 'choices.js'

class ChoicesDropdown extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._choices = null
        this._options = {
            ...{
                searchEnabled: false,
                removeItems: false,
                paste: false,
                itemSelectText: '',
                shouldSort: false,
                position: 'bottom'
            }, ...this._options
        }
    }

    setValue(value) {
        this._choices.setChoiceByValue(value)
        this._elem.dispatchEvent(new Event('change'))
    }

    getValue() {
        return this._choices.getValue()
    }

    getOptions() {
        return this._selectOptions
    }

    async mount() {
        this._selectOptions = [...this._elem.options]
        this._choices = new Choices(this._elem, this._options)
    }
}

export default ChoicesDropdown
